import { defineComponent as _defineComponent } from 'vue'
import ItemListaDetalhes from '@/components/ItemListaDetalhes.vue'
import { formatarData } from '@/shareds/formatadores'
import Irmao from '@/../common/types/Irmao'
import dayjs from 'dayjs';
import { formatarTelefone } from '@/shareds/formatadores'


export default /*#__PURE__*/_defineComponent({
  __name: 'AbaGeralDoIrmao',
  props: {
    irmao: null
  },
  setup(__props: any) {



function calcularIdade(data: string) {
	return dayjs().diff(dayjs(data), 'years')
}

return { __sfc: true,calcularIdade, ItemListaDetalhes, formatarData, formatarTelefone }
}

})